<div mat-dialog-content *ngIf="table$ | async; let table">

  <p i18n>Use the button below to export the current table with selected filters</p>

  <form *ngIf="formData" [formGroup]="formData.form" (ngSubmit)="onSubmit()">
    <app-form-fields [formData]="formData"></app-form-fields>
  </form>
  <button mat-flat-button color="primary" (click)="startExport()" i18n>Export</button>

  <div *ngIf="table.meta.total > 0">
    <p i18n>
      Existing exports
    </p>
    <eas-table [table]="table" [defaultColumns]="columns"></eas-table>
  </div>

</div>
<div mat-dialog-actions>
  <ub-button-list>
    <button mat-flat-button
            color="warn"
            [mat-dialog-close] i18n>Close</button>
  </ub-button-list>
</div>
